import React , {Component} from "react";
import MyContext from '../MyContext.jsx';
import {Link} from "react-router-dom";
import { CgSearch } from 'react-icons/cg';
import Select from "react-select";
import DatePicker from 'react-date-picker';

import './ExecutiveWiseReport.scss';

class ExecutiveWiseReport extends Component{
  constructor(props){
    super(props);
    this.executiveSelect = React.createRef();

    this.state = {
      zones    :   [],
      zone :   {},
      customers : [],
      showing_customers:[],
      categories    :   [],
      category :   {},
      search:'',
      from_date : new Date(),
      to_date : new Date(),
      executives  : [],
      executive  : {},
      minDate : new Date(new Date().getFullYear()-1, new Date().getMonth(), 1 ),
      maxDate : new Date(new Date().getFullYear(), new Date().getMonth()+1, 0),
      total_exe_wise_quantity : 0
    }
    this.zoneChange = this.zoneChange.bind(this);
    this.executiveChange = this.executiveChange.bind(this);
    this.formChange = this.formChange.bind(this);
    this.formSubmit = this.formSubmit.bind(this);


  }
  componentDidMount(){
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/get/executives`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
         executives : return_data.executives,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
   }).fail(function(){
        obj_this.context.loading(0);
        alert("Network error");
        obj_this.props.history.replace("/");
    });

    const url3 = `${process.env.REACT_APP_SSS}/api/get/productCategories`;
    this.context.loading(1);
    $.ajax({
      url : url3,
      data : {
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
         categories : return_data.categories,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
   }).fail(function(){
        obj_this.context.loading(0);
        alert("Network error");
        obj_this.props.history.replace("/");
    });



    // const url2 = `${process.env.REACT_APP_SSS}/api/reports/getExecutiveWisereport`;
    // this.context.loading(1);
    // $.ajax({
    //   url : url2,
    //   data : {
    //     sid : this.context.user_details.sid,
    //   },
    //   type : "POST"
    // }).done(function(return_data){
    //   console.log(return_data);
    //   if(return_data.status == "success"){
    //     obj_this.setState({
    //      customers : return_data.customers,
    //      showing_customers:return_data.customers
    //     });
    //     obj_this.context.loading(0);
    //   }else{
    //     obj_this.context.loading(0);
    //     obj_this.props.history.replace("/");
    //   }
    // }).fail(function(){
    //   alert("Network error");
    //   obj_this.context.loading(0);

    // });

    
  }

  formChange(e){
    // console.log(e.target.value);
    var showing_schedule =[];
    if(e.target.value){
      showing_schedule = this.state.showing_customers.filter((item) => {return item.name.toLowerCase().includes(e.target.value.toLowerCase())});
    }
    else{
      showing_schedule = this.state.customers;
    }
    // showing_customers = showing_customers.length?showing_customers:this.state.doc_name;
    this.setState({
      showing_customers : showing_schedule
    });
  }

  zoneChange(option){
    this.setState({
      zone : option
    });
  } 
  categoryChange(option){
    this.setState({
      category : option
    });
  }  
  executiveChange(option){
    var obj_this = this;
    console.log(option);
    this.setState({
      executive : option,
      zone : null
    });
    const url = `${process.env.REACT_APP_SSS}/api/get/mappedZones`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        executive_id:  option.value
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
          zones : return_data.zone_mapped,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
   }).fail(function(){
        obj_this.context.loading(0);
        alert("Network error");
        obj_this.props.history.replace("/");
    });
  } 

  formSubmit(e){
    e.preventDefault();
    $(".customer_outstandings_table tr").css("backgroud-color","");
    if(!this.state.executive.value){
      this.executiveSelect.current.focus();
      return;
    }
     
    var obj_this = this;
    const url2 = `${process.env.REACT_APP_SSS}/api/reports/getExecutiveWisereport`;
    this.context.loading(1);
    $.ajax({
      url : url2,
      data : {
        sid : this.context.user_details.sid,
        zone_id : this.state.zone?this.state.zone.value:null,
        from_date : this.state.from_date.toLocaleDateString('en-CA'),
        to_date : this.state.to_date.toLocaleDateString('en-CA'),
        executive_id  :   this.state.executive.value,
        category_id : this.state.category.value
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      var customers =[]
      // return;
      
      if(return_data.status == "success"){
          customers = return_data.customers.sort(function(a,b){
          return  b.qty - a.qty 
        });
        obj_this.setState({
         customers : customers,
         showing_customers:customers,
         total_exe_wise_quantity : return_data.total_exe_wise_quantity
        });
        // debugger;
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      obj_this.context.loading(0);
      alert("Network error");
    });
   
    
  }


  fromDateChange(value){
    // console.log(value);
    this.setState({from_date : value});
  }
  toDateChange(value){
    // console.log(value);
    this.setState({to_date : value});
  }



  
    

  render(){
    return(
      <MyContext.Consumer>
        {context => (
        <div className="executive_wise_report_page_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Executive Wise Report</div>
          </div> 
          <form className="executive_due_period_form" onSubmit={this.formSubmit}>
            <div className="blocks">
              <div className="input_grid">
                <div className="form_input">
                  <div className="from_to_label">
                    <div className="input_label">From Date</div>
                    <DatePicker
                      className="input custom_input"
                      onChange={(value) => this.fromDateChange(value)}
                      value={this.state.from_date}
                      minDate = {this.state.minDate}
                      maxDate = {this.state.maxDate}
                      clearIcon={null}
                      required
                      format="dd-MM-y"
                    />
                    <div className="input_label">To Date</div>
                    <DatePicker
                      className="input custom_input"
                      onChange={(value) => this.toDateChange(value)}
                      value={this.state.to_date}
                      minDate = {new Date(this.state.from_date)}
                      maxDate = {this.state.maxDate}
                      clearIcon={null}
                      required
                      format="dd-MM-y"
                    />
                  </div>
                  <div className="input_label">Executives</div>
                  <Select 
                    options={this.state.executives}  
                    value ={this.state.executive}
                    className="executive" 
                    ref={this.executiveSelect}
                    onChange={e => this.executiveChange(e)}
                    required
                  />
                  <div className="input_label">Product Category</div>
                  <Select 
                    options={this.state.categories}  
                    value ={this.state.category}
                    className="executive" 
                    onChange={e => this.categoryChange(e)}
                    // required
                  />
                  <div className="input_label">Zones</div>
                  <Select 
                    options={this.state.zones}  
                    value ={this.state.zone}
                    className="executive" 
                    ref={this.zoneSelect}
                    onChange={e => this.zoneChange(e)}
                    required
                  />
                  <div className="submit_button_container">
                    <button className="submit_button">Submit</button>
                  </div>
                </div>
                
                </div>
                
            </div>
          </form>
          <div className="search_container">
            <CgSearch/>
            <input className="customer_search_input" 
              placeholder="Search Customers.."
              onChange={this.formChange}
              value={this.search}
            />
          </div>
          <div className="table_container">
            <table className="customer_outstandings_table">
              <thead>
                <tr>
                  <th style={{maxWidth:"40px"}} align="center">#</th>
                  <th>Customer</th>
                  <th  align="center">Qty </th>

                </tr>
              </thead>
              <tbody>
              <tr style={{display:this.state.showing_customers.length?"none":"table-row"}}>
                <td colSpan="3" align="center">No result!</td>
              </tr>
              {this.state.showing_customers && this.state.showing_customers.map((cust,index) => (
                <tr key={index}  style={{backgroundColor:cust.pending_total>0 && !cust.no_due?"#ffa8b3":""}}>
                  <td valign="top" align="center">{index+1}</td>
                  <td valign="top" style={{padding:"5px 0px"}}>
                    <div style={{fontWeight:"500",paddingLeft:"5px"}}>{cust.name}</div>
                  </td>
                  <td valign="top" align="center">{cust.qty}</td>
                </tr>
              ))}
              <tr style={{display:this.state.showing_customers.length?"table-row":"none"}}>
                <td colSpan="2" align="center" style={{fontSize:'12px',fontWeight:"800"}}>Total </td>
                <td align="center" style={{fontSize:'12px',fontWeight:"800"}}>{this.state.total_exe_wise_quantity}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      )}
    </MyContext.Consumer>
  )}
}

export default ExecutiveWiseReport;
ExecutiveWiseReport.contextType = MyContext;
